<template>
    <div class="flex items-center justify-center">
        <svg
            v-if="icon === 'arrow-redo'"
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="none"
            :class="svgClass"
        >
            <path
                :class="pathClass"
                fill="currentColor"
                fill-rule="evenodd"
                d="M12.743 1.91a.833.833 0 0 1 1.179 0l2.5 2.5a.833.833 0 0 1 0 1.18l-2.5 2.5a.833.833 0 1 1-1.179-1.18l1.078-1.077H7.916a4.583 4.583 0 1 0 0 9.167h6.25a.833.833 0 1 1 0 1.666h-6.25a6.25 6.25 0 1 1 0-12.5h5.905L12.743 3.09a.833.833 0 0 1 0-1.178Z"
                clip-rule="evenodd"
            />
        </svg>
        <svg
            v-if="icon === 'mini-card'"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                x="3.7998"
                y="3.19971"
                width="8.4"
                height="9.6"
                rx="0.6"
                stroke="#64748B"
                stroke-width="0.6"
            />
            <path
                d="M10.4 8.8V7.6C10.4 7.3792 10.2208 7.2 10 7.2H6C5.7792 7.2 5.6 7.3792 5.6 7.6V8.8C5.6 9.0208 5.7792 9.2 6 9.2H10C10.2208 9.2 10.4 9.0208 10.4 8.8Z"
                fill="#64748B"
            />
            <path d="M2 5.6H14V6.8H2V5.6Z" fill="#64748B" />
        </svg>
        <svg
            v-if="icon === 'generic-card'"
            :width="width"
            :height="height"
            viewBox="0 0 82 50"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            :class="svgClass"
        >
            <g clip-path="url(#clip0_2679_10706)">
                <path
                    d="M1 5C1 2.79086 2.79086 1 5 1H77C79.2091 1 81 2.79086 81 5V45C81 47.2091 79.2091 49 77 49H5C2.79086 49 1 47.2091 1 45V5Z"
                    fill="#E2E8F0"
                />
                <rect x="1" y="11" width="80" height="12.5" fill="#CBD5E1" />
            </g>
            <path
                d="M1 5C1 2.79086 2.79086 1 5 1H77C79.2091 1 81 2.79086 81 5V45C81 47.2091 79.2091 49 77 49H5C2.79086 49 1 47.2091 1 45V5Z"
            />
            <defs>
                <clipPath id="clip0_2679_10706">
                    <rect width="82" height="50" fill="white" />
                </clipPath>
            </defs>
        </svg>
        <svg
            v-if="icon === 'unmatched-card' || icon === 'unknown-card'"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M4.99951 6C4.44723 6 3.99951 6.44772 3.99951 7V9H19.9995V6.99975C19.9995 6.44763 19.552 6 18.9995 6H4.99951ZM19.9995 11H3.99951V17C3.99951 17.5523 4.44723 18 4.99951 18H18.9995C19.5518 18 19.9995 17.5523 19.9995 17V11ZM1.99951 7C1.99951 5.34315 3.34266 4 4.99951 4H18.9995C20.6562 4 21.9995 5.34274 21.9995 6.99975V17C21.9995 18.6569 20.6564 20 18.9995 20H4.99951C3.34266 20 1.99951 18.6569 1.99951 17V7ZM5.99951 14C5.99951 13.4477 6.44723 13 6.99951 13H9.99951C10.5518 13 10.9995 13.4477 10.9995 14C10.9995 14.5523 10.5518 15 9.99951 15H6.99951C6.44723 15 5.99951 14.5523 5.99951 14Z"
                fill="#64748B"
            />
            <path
                d="M18.4824 12C20.5535 12 22.2324 13.6789 22.2324 15.75C22.2324 16.5656 22.0108 17.2809 21.5576 17.8701C21.1505 18.3994 20.6386 18.7049 20.3906 18.8555C20.3187 18.8992 20.2627 18.9341 20.2178 18.9619C20.1515 19.5102 19.8326 19.9786 19.3799 20.25C19.89 20.5558 20.2324 21.112 20.2324 21.75V21.7598C20.2324 22.7263 19.4489 23.5098 18.4824 23.5098C17.516 23.5097 16.7324 22.7262 16.7324 21.7598V21.75C16.7324 21.1124 17.0744 20.5559 17.584 20.25C17.0744 19.9441 16.7324 19.3876 16.7324 18.75C16.7324 17.9246 17.0072 17.2298 17.498 16.6875C17.8607 16.2868 18.3074 16.0234 18.5146 15.8994L18.5391 15.8848L18.541 15.8828C18.5529 15.8757 18.5643 15.8703 18.5742 15.8643C18.6455 15.821 18.695 15.7862 18.7314 15.7617C18.7315 15.758 18.7324 15.7541 18.7324 15.75C18.7324 15.6119 18.6205 15.5 18.4824 15.5C18.391 15.5001 18.3099 15.5479 18.2646 15.626C17.7807 16.4626 16.7106 16.7486 15.874 16.2646C15.0375 15.7807 14.7516 14.7106 15.2354 13.874C15.8809 12.7581 17.0919 12.0001 18.4824 12Z"
                fill="#64748B"
                stroke="#F1F5F9"
                stroke-width="1.5"
                stroke-linecap="round"
            />
            <path
                d="M18.4826 14.75C18.1137 14.75 17.7902 14.9492 17.6158 15.2507C17.3392 15.7288 16.7275 15.8921 16.2494 15.6156C15.7714 15.3391 15.608 14.7273 15.8846 14.2493C16.4018 13.3552 17.3709 12.75 18.4826 12.75C20.1395 12.75 21.4826 14.0931 21.4826 15.75C21.4826 16.4233 21.302 16.9719 20.9627 17.413C20.6493 17.8204 20.2493 18.0641 20.0016 18.2145C19.7018 18.3966 19.6036 18.4584 19.5365 18.5324L19.5334 18.5357C19.5173 18.5526 19.4826 18.5889 19.4826 18.75C19.4826 19.3023 19.0349 19.75 18.4826 19.75C17.9303 19.75 17.4826 19.3023 17.4826 18.75C17.4826 18.1026 17.6929 17.589 18.0537 17.1903C18.3317 16.8832 18.6862 16.6711 18.8998 16.5433L18.8998 16.5433C18.9228 16.5296 18.9441 16.5168 18.9636 16.505C19.2159 16.3518 19.3159 16.2736 19.3775 16.1935C19.4132 16.1471 19.4826 16.0426 19.4826 15.75C19.4826 15.1977 19.0349 14.75 18.4826 14.75Z"
                fill="#64748B"
            />
            <path
                d="M18.4826 20.75C19.0349 20.75 19.4826 21.1977 19.4826 21.75V21.76C19.4826 22.3123 19.0349 22.76 18.4826 22.76C17.9303 22.76 17.4826 22.3123 17.4826 21.76V21.75C17.4826 21.1977 17.9303 20.75 18.4826 20.75Z"
                fill="#64748B"
            />
        </svg>
    </div>
</template>

<script setup>
defineProps({
    icon: {
        type: String,
        required: true,
    },
    svgClass: {
        type: String,
        default: 'fill-none',
    },
    pathClass: {
        type: String,
        default: 'fill-slate-800',
    },
    width: {
        type: Number,
        default: 20,
    },
    height: {
        type: Number,
        default: 20,
    },
    size: {
        type: String,
        default: 'medium',
    },
});
</script>
